__turbopack_context__.v({
  "chevron": "zG5hwa_chevron",
  "chevronDown": "zG5hwa_chevronDown",
  "languageFilterContainer": "zG5hwa_languageFilterContainer",
  "languageFilterControl": "zG5hwa_languageFilterControl",
  "languageFilterControlText": "zG5hwa_languageFilterControlText",
  "languageFilterDescription": "zG5hwa_languageFilterDescription",
  "languageFilterIcon": "zG5hwa_languageFilterIcon",
  "languageFilterIndicatorSeparator": "zG5hwa_languageFilterIndicatorSeparator",
  "languageFilterLanguage": "zG5hwa_languageFilterLanguage",
  "languageFilterMenuCheckbox": "zG5hwa_languageFilterMenuCheckbox",
  "languageFilterMenuItem": "zG5hwa_languageFilterMenuItem",
  "languageFilterMenuList": "zG5hwa_languageFilterMenuList",
  "languageFilterValueContainerContents": "zG5hwa_languageFilterValueContainerContents",
  "svg": "zG5hwa_svg",
  "wrapper": "zG5hwa_wrapper",
});
